import React, { useEffect } from "react";
import Layout from "./layout";
import Welcome from "../component/welcome";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../features/authSlice";
import HargaJual from "../component/harga-jual";
import HargaChart from "../component/harga-jual-grafik";
import JumlahVarietas from "../component/JumlahVarietas";
import { Container, Row, Col } from "react-bootstrap";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);

  return (
    <Layout>
      <Container fluid>
       
        <Row className="mb-2 mt-3">
          <Col md={6} >
            <Welcome />
          </Col>
          <Col md={6} className="mb-2">
            <HargaJual />
          </Col>
        </Row>
        <Row>
          <Col>
            <JumlahVarietas />
          </Col>
        </Row>
        <Row>
          <Col>
            <HargaChart />
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default Dashboard;
